
import { defineComponent } from "vue";

export default defineComponent({
  name: "grid-template-columns",
});
